import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2c6357"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "title-payment" }
const _hoisted_3 = { class: "text--center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "title-dialog-payment mt-1"
}

import { functions, firestore } from "@/config/firebase";
import { ShoppingCart } from "@/models/events/checkout/shopping-cart.model";
import { CartItem } from "@/vue-core/models/checkout/cart-item.model";
import CardPaymentBooking from "@/components/payments/CardPaymentBooking.vue";
import BookingDetails from "@/components/hotels/BookingDetails.vue";
import {
  bookingFormProps,
  optionalBookingFormProps,
} from "@/models/events/bookings/BookingFormProps";
import { ref, onMounted, computed, reactive, watch, inject } from "vue";
import router from "@/config/router";
import { useRoute } from "vue-router";
import { CheckoutCharge } from "@/models/events/checkout/subtotal.model";
import i18n from "@/i18n";
import { loaderStart, loaderDone } from "@/services/Loader";
import { showMessage } from "@/services/MessageService";
import { useStore } from "vuex";
import { Booking, Companion } from "@/vue-core/models/HotelBooking.model";
import { Payments, Status } from "@/vue-core/models/HotelRoomBlock.model";
import useBreakpoints from "@/services/Breakpoints";

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingsPayment',
  setup(__props) {

const stripeDialogVisible = ref(false);
const couponInput = ref("");
const shoppingCart = ref({} as ShoppingCart);
const stripeAccountId = ref("");
const stripeClientSecret = ref("");
const validCoupong = ref(false);
const route = useRoute();
const store = useStore();
const adultSelected = ref(parseInt(route.query.adultSelected as string));
const childSelected = ref(parseInt(route.query.childSelected as string));
const isSelectedAddComments = ref(false);
const bookingPriceIsZero = ref(false);
const hasCompanion = ref(false);
const form = ref<any>(null);
const optionalForm = ref<any>(null);
const payment = ref<any>(null);
const bookingRules = bookingFormProps;
const companion = ref({
  firstName: "",
  lastName: "",
  secondLastName: "",
} as Companion);
const { type } = useBreakpoints();
const eventData = computed(() => {
  return store.getters["user/eventData"];
});
const booking = reactive<Booking>({
  id: "",
  hotel: {
    id: route.params.hotelID as string,
    contactPhone: "",
    address: "",
    name: "",
  },
  guest: {
    fullName: "",
    firstName: "",
    lastName: "",
    secondLastName: "",
    phone: "",
    email: "",
  },
  checkIn: new Date(),
  checkOut: new Date(),
  adultSelected: parseInt(route.query.adultSelected as string),
  childSelected: parseInt(route.query.childSelected as string),
  totalAmount: 0,
  currency: "",
  cartRooms: [],
  charges: [],
  nights: 0,
  additionalComments: "",
  subtotalAmount: 0,
  amountCoupon: 0,
  typePayment: Payments.stripe,
  bookingStatus: Status.pending,
  isModified: false,
  rooms: [],
});
const bookingDetailsRef = ref<any>(null);
const isMobile = computed(() => {
  return type.value === "sm" || type.value === "md";
});
function resetItems() {
  if (booking.cartRooms) booking.cartRooms.splice(0, booking.cartRooms.length);
  if (booking.charges) booking.charges.splice(0, booking.charges.length);
}
const participantData = computed(() => {
  return store.getters["user/participantData"];
});
const applyCoupon = async () => {
  loaderStart();
  const getCoupon = functions.httpsCallable("getStripeCoupon");
  const stripeCouponValidation = functions.httpsCallable(
    "stripeCouponValidation"
  );
  const response = await getCoupon({
    coupongId: couponInput.value,
    eventId: route.params.eventID,
  });
  if (response.data === "not-exist") {
    showMessage({
      title: i18n.global.t("coupon.noExist"),
      message: i18n.global.t("coupon.noExistDetail"),
      type: "warning",
    });
  } else if (response.data) {
    const validRedemptions = await stripeCouponValidation({
      coupongId: couponInput.value,
      eventId: route.params.eventID,
      coupongType: "booking",
    });
    if (validRedemptions.data === "valid") {
      await store.dispatch("user/updateReservationParticipant", {
        eventID: route.params.eventID,
        hotelID: route.params.hotelID,
        cartRooms: booking.cartRooms,
        charges: booking.charges,
        coupon: response.data,
      });
      if (response.data.amount_off) {
        booking.amountCoupon = response.data.amount_off;
      } else {
        booking.amountCoupon = parseFloat(
          ((response.data.percent_off * booking.subtotalAmount) / 100).toFixed(
            2
          )
        );
      }
      await setBooking();
      showMessage({
        title: i18n.global.t("coupon.validCoupon"),
        message: i18n.global.t("coupon.validCouponDetail"),
        type: "success",
      });
      validCoupong.value = true;
    } else {
      showMessage({
        title: i18n.global.t("coupon.errorCoupon"),
        message: i18n.global.t("coupon.errorCouponDetail"),
        type: "warning",
      });
    }
  } else {
    showMessage({
      title: i18n.global.t("coupon.errorCoupon"),
      message: i18n.global.t("coupon.errorCouponDetail"),
      type: "warning",
    });
  }
  loaderDone();
};
watch(isSelectedAddComments, () => {
  if (!isSelectedAddComments.value) {
    booking.additionalComments = "";
  }
});
const getShoppingCart = async () => {
  const getPaymentIntents = functions.httpsCallable("getPaymentIntents");
  const response = (
    await getPaymentIntents({
      eventId: eventData.value.id,
      productType: "booking",
    })
  ).data as ShoppingCart;
  if (response === "value-0") {
    shoppingCart.value = await getShoppingCartWhenPriceZero();
    bookingPriceIsZero.value = true;
  } else {
    shoppingCart.value = response;
    bookingPriceIsZero.value = false;
  }
};

const getShoppingCartWhenPriceZero = async () => {
  const cartsList = await firestore("events")
    .doc(eventData.value.id)
    .collection("participants")
    .doc(participantData.value.uid)
    .collection("carts")
    .orderBy("updatedLast", "desc")
    .limit(1)
    .get();
  return cartsList.docs[0].data() as ShoppingCart;
};

const preparePaymentForm = async (charge: CheckoutCharge) => {
  loaderStart();
  if (
    charge &&
    charge.paymentIntentClientSecret &&
    charge.stripeAccountId &&
    !bookingPriceIsZero.value
  ) {
    stripeAccountId.value = charge.stripeAccountId;
    stripeClientSecret.value = charge.paymentIntentClientSecret;
  } else if (
    bookingPriceIsZero.value &&
    shoppingCart.value.subtotals &&
    shoppingCart.value.subtotals[0].amount <= 0
  ) {
    await store.dispatch("user/saveBooking", {
      booking: booking,
      cartID: shoppingCart.value.id,
      fromDate: booking.checkIn.getTime(),
      toDate: booking.checkIn.getTime(),
      couponID: couponInput.value,
    });
  } else {
    showMessage({
      title: i18n.global.t("hotels.errorPayBooking.title"),
      message: i18n.global.t("hotels.errorPayBooking.message"),
      type: "error",
    });
    router.push({
      name: "Hotels",
      params: { eventID: eventData.value.id },
    });
  }
  loaderDone();
};
const setHotelData = async () => {
  const hotelData = await store.dispatch("user/getHotelData", {
    eventID: route.params.eventID,
    hotelID: route.params.hotelID,
  });
  booking.hotel.name = hotelData.name;
  booking.hotel.address = hotelData.address;
  booking.hotel.contactPhone = hotelData.contactPhone;
};
const setGuestData = () => {
  booking.guest.email = participantData.value.email;
  booking.guest.fullName = participantData.value.fullName;
  booking.guest.firstName = participantData.value.firstName;
  booking.guest.lastName = participantData.value.lastName;
  booking.guest.secondLastName = participantData.value.secondLastName;
  booking.guest.phone = participantData.value.phone;
  booking.createdBy = participantData.value.uid;
};
const setDates = () => {
  const fromDate = new Date(route.query.fromDate as string);
  fromDate.setHours(0, 0, 0, 0);
  booking.checkIn = new Date(fromDate.setDate(fromDate.getDate() + 1));
  const toDate = new Date(route.query.toDate as string);
  toDate.setHours(0, 0, 0, 0);
  booking.checkOut = new Date(toDate.setDate(toDate.getDate() + 1));
  const timeDiff = Math.abs(
    booking.checkOut.getTime() - booking.checkIn.getTime()
  );
  booking.nights = Math.ceil(timeDiff / (1000 * 3600 * 24));
};
const setRooms = (rooms: Array<any>) => {
  for (const room of rooms) {
    if (!room.product.roomType) {
      if (booking.charges) booking.charges.push(room);
    } else {
      if (booking.cartRooms) {
        booking.cartRooms.push(room);
        booking.rooms?.push({
          id: room.product.id,
          name: room.product.name,
          quantityPerNight: room.quantity / booking.nights,
          dates: [],
        });
      }
    }
  }
};
const setBooking = async () => {
  loaderStart();
  try {
    resetItems();
    await getShoppingCart();
    if (participantData.value.status !== "paid") {
      router.push({
        name: "Checkout",
        params: { eventID: route.params.eventID },
      });
    }
    if (
      shoppingCart.value &&
      shoppingCart.value.items &&
      shoppingCart.value.subtotals
    ) {
      await setHotelData();
      setGuestData();
      setDates();
      setRooms(shoppingCart.value.items);
      booking.totalAmount = shoppingCart.value.subtotals[0].amount;
      booking.currency = shoppingCart.value.subtotals[0].currency;
      booking.subtotalAmount = parseFloat(subtotalAmount.value.toFixed(2));
    } else {
      router.push({
        name: "Hotels",
        params: { eventID: route.params.eventID },
      });
    }
  } catch (error) {
    router.push({
      name: "Hotels",
      params: { eventID: route.params.eventID },
    });
  } finally {
    loaderDone();
  }
};
function filterSize() {
  if (type.value === "lg") return "20%";
  if (type.value === "md") return "30%";
  return "80%";
}
const subtotalAmount = computed(() => {
  let subtotalAmount = 0;
  if (shoppingCart.value.subtotals) {
    subtotalAmount = shoppingCart.value.subtotals[0].amount / 1.16;
  }
  return subtotalAmount;
});
async function onFormSubmit() {
  if (bookingDetailsRef.value)
    booking.additionalComments = bookingDetailsRef.value.additionalComments;
  if (!(await form.value.validate())) return;
  if (hasCompanion.value && !(await optionalForm.value.validate())) return;
  if (hasCompanion.value) booking.companion = companion.value;
  payment.value.onFormSubmit();
}
onMounted(async () => {
  await setBooking();
  if (
    shoppingCart.value &&
    shoppingCart.value.subtotals &&
    shoppingCart.value.subtotals[0].checkout
  )
    preparePaymentForm(shoppingCart.value.subtotals[0].checkout);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      type: "flex",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 7,
          lg: 7,
          xl: 7
        }, {
          default: _withCtx(() => [
            _createVNode(BookingDetails, {
              ref_key: "bookingDetailsRef",
              ref: bookingDetailsRef,
              bookingData: booking,
              shoppingCart: shoppingCart.value
            }, null, 8, ["bookingData", "shoppingCart"]),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 20,
                  md: 20,
                  lg: 20,
                  xl: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      "data-test": "coupon",
                      label: _ctx.$t('coupon.input'),
                      modelValue: couponInput.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponInput).value = $event))
                    }, null, 8, ["label", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  xl: 4,
                  class: "mobile__button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "ml-2 primary__color__button",
                      onClick: applyCoupon
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("coupon.apply")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!isMobile.value)
          ? (_openBlock(), _createBlock(_component_el_divider, {
              key: 0,
              direction: "vertical"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 7,
          lg: 7,
          xl: 7
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("hotels.bookingCheckout.guestInformation")), 1),
            _createVNode(_component_el_form, {
              "label-position": "top",
              "label-width": "100px",
              style: {"max-width":"460px"},
              size: "small",
              ref_key: "form",
              ref: form,
              model: booking
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('accountSettings.lastName'),
                  prop: "guest.lastName",
                  rules: _unref(bookingFormProps).lastName
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: booking.guest.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((booking.guest.lastName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('accountSettings.secondLastName'),
                  prop: "guest.secondLastName",
                  rules: _unref(bookingFormProps).secondLastName
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: booking.guest.secondLastName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((booking.guest.secondLastName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('accountSettings.firstName'),
                  prop: "guest.firstName",
                  rules: _unref(bookingFormProps).firstName
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: booking.guest.firstName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((booking.guest.firstName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('accountSettings.email'),
                  prop: "guest.email",
                  rules: _unref(bookingFormProps).email
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: booking.guest.email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((booking.guest.email) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('accountSettings.phoneNumber'),
                  prop: "guest.phone",
                  rules: _unref(bookingFormProps).participantPhone
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: booking.guest.phone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((booking.guest.phone) = $event)),
                      modelModifiers: { number: true },
                      maxlength: "10",
                      minlength: "10"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("hotels.bookingCheckout.additionalFields")), 1),
            _createVNode(_component_el_checkbox, {
              modelValue: hasCompanion.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((hasCompanion).value = $event)),
              label: _ctx.$t('hotels.bookingCheckout.addCompanion'),
              size: "large"
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_Transition, { name: "smooth" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_el_form, {
                    "label-position": "top",
                    "label-width": "100px",
                    ref_key: "optionalForm",
                    ref: optionalForm,
                    style: {"max-width":"460px"},
                    size: "small",
                    model: companion.value,
                    rules: _ctx.rules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('accountSettings.lastName'),
                        prop: "lastName",
                        rules: _unref(optionalBookingFormProps).lastName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: companion.value.lastName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((companion.value.lastName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('accountSettings.secondLastName'),
                        prop: "secondLastName",
                        rules: _unref(optionalBookingFormProps).secondLastName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: companion.value.secondLastName,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((companion.value.secondLastName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('accountSettings.firstName'),
                        prop: "firstName",
                        rules: _unref(optionalBookingFormProps).firstName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: companion.value.firstName,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((companion.value.firstName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ], 512), [
                  [_vShow, hasCompanion.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!isMobile.value)
          ? (_openBlock(), _createBlock(_component_el_divider, {
              key: 1,
              direction: "vertical"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 7,
          lg: 7,
          xl: 7
        }, {
          default: _withCtx(() => [
            _createVNode(CardPaymentBooking, {
              ref_key: "payment",
              ref: payment,
              stripeClientSecret: stripeClientSecret.value,
              stripeAccountId: stripeAccountId.value,
              couponId: couponInput.value,
              couponApply: validCoupong.value,
              booking: booking,
              cartID: shoppingCart.value.id,
              subtotal: subtotalAmount.value,
              fromDate: booking.checkIn.getTime(),
              toDate: booking.checkOut.getTime()
            }, null, 8, ["stripeClientSecret", "stripeAccountId", "couponId", "couponApply", "booking", "cartID", "subtotal", "fromDate", "toDate"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                id: "submit",
                onClick: _withModifiers(onFormSubmit, ["prevent"]),
                class: "secondary__color__button btn-pay"
              }, _toDisplayString(_ctx.$t("register.payment.pay")), 9, _hoisted_4)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: stripeDialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((stripeDialogVisible).value = $event)),
      center: "true",
      width: filterSize()
    }, {
      title: _withCtx(() => [
        (!bookingPriceIsZero.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("register.payment.paymentDialogTitle")), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}
}

})